import script from "./CatalogCategoryViewV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogCategoryViewV2.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogCategoryViewV2.vue?vue&type=style&index=0&id=5cecd998&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cecd998"]])

export default __exports__